const ENActions = {
	"Ação": "Action",
	"Ação movida com sucesso": "Action moved successfully",
	"Ação adicionada com sucesso": "Action added successfully",
	"Ação alterada com sucesso": "Action changed successfully",
	"Ação copiada com sucesso": "Action copied successfully",
	"Ação excluída com sucesso": "Action deleted successfully",
	"Ação mapa estratégico": "Action strategic map",
	"Solicitação de postergação realizada com sucesso": "Postponement request successfully realized",
	"Ação tem subação em aberto": "Action has subaction opened",
	"Ações com subações": "Actions with subactions",
	"Alerta postergação": "Alert postpone",
	"Alerta cancelamento": "Alert cancel",
	"Adicionar ação": "Add action",
	"Adicionar eficácia": "Add efficiency",
	"Adicionar subação": "Add subaction",
	"Alterar ação": "Change action",
	"Alterar Fase": "Change Phase",
	"Alterar Sprint": "Change Sprint",
	"Alteração no checklist": "Change in checklist",
	"Ao alterar os checklist, os percentuais do andamento da ação e seus respectivos históricos serão recalculados": "When changing the checklist, the action progress percentages and their respective histories will be recalculated",
	"Apenas autoridade, responsável ou administrador pode alterar o andamento": "Only authority, responsible or administrator can change the progress",
	"Apenas autoridade ou administrador pode confirmar a postergação": "Only authority or administrator can confirm postponement",
	"Apenas autoridade ou administrador pode confirmar o cancelamento": "Only authority or administrator can confirm cancel",
	"Caso seja selecionado um objetivo, será criado uma iniciativa e uma respectiva ação dentro dela. Caso seja escolhido uma iniciativa, será cadastrada a ação diretamente na iniciativa": "If an objective is selected, an initiative and an action will be created within it. If an initiative is selected, the action will be registered directly in the initiative",
	"Copiar ação": "Copy action",
	"Clique para abrir a rastreabilidade": "Click to open traceability",
	"Data anterior": "Previous date",
	"Data postergação": "Postponement date",
	"Defina a configuração dos valores da ação. Ela pode ser definida diretamente com seus valores totais ou mês a mês": "Set the action values ​​setting. It can be set directly with your total amounts or month by month",
	"Defina o número de dias que será utilizado para alertar no painel se a eficácia está ou não atrasada": "Set the number of days that will be used to alert the dashboard whether effectiveness is delayed or not",
	"Deseja continuar": "Do you wish to continue",
	"Deseja copiar a rastreabilidade da ação": "Do you want to copy the action's traceability",
	"Deseja realmente excluir a ação": "Do you really want to delete the action",
	"Deseja realmente excluir a eficácia": "Do you really want to delete the efficiency",
	"Eficácia inserida com sucesso": "Efficiency entered successfully",
	"Eficácia excluída com sucesso": "Efficiency successfully deleted",
	"Eficácia atrasada": "Efficiency delayed",
	"Erro ao adicionar ação": "Error adding action",
	"Erro ao adicionar eficácia": "Error adding efficiency",
	"Erro ao alterar ação": "Error changing action",
	"Erro ao buscar a rastreabilidade": "Error fetching traceability",
	"Erro ao copiar ação": "Error copying action",
	"Erro ao carregar as ações": "Error loading actions",
	"Erro ao carregar orçamento": "Error loading budget",
	"Erro ao concluir ação": "Error completing action",
	"Erro ao excluir ação" :"Error deleting action",
	"Erro ao excluir eficácia": "Error deleting efficiency",
	"Erro ao selecionar ação": "Error selecting action",
	"Erro ao mover ação": "Error moving action",
	"Essa ação é uma tarefa, portanto insira uma data final para esse andamento": "This action is a task, so enter an end date for this progress",
	"Exclusão da ação": "Delete action",
	"Exclusão de eficácia": "Delete efficiency",
	"Finalizar": "Finish",
	"Finalizar ação": "Complete action",
	"Grupo de qualidade é requerido": "Quality group is required",
	"Iniciar": "Start",
	"Indefinido": "Undefined",
	"Informe uma data final para a recorrência": "Enter an end date for the recurrence",
	"Mapa estratégico": "Strategic map",
	"Manter Rastreabilidade": "Keep Traceability",
	"Mês previsto de conclusão": "Expected completion month",
	"Minhas ações": "My actions",
	"Não há nenhum verificação da eficácia": "There is no verification of effectiveness",
	"Nova ação": "New action",
	"Nova subação": "New subaction",
	"Nova data proposta": "New proposed date",
	"Pausar": "Pause",
	"Painel de Ações": "Actions Panel",
	"Postergações": "Postponements",
	"Previsto despesa": "Expected expense",
	"Previsto receita": "Expected revenue",
	"Reabrir ação": "Reopen action",
	"Rejeitada": "Rejected",
	"Registro de postergação realizado com sucesso": "Postponement record successfully realized",
	"Realizado despesa": "Realized expense",
	"Realizado receita": "Realized revenue",
	"Requer eficácia": "Efficiency required",
	"Selecione apenas um objetivo ou iniciativa": "Select only one objective or iniciative",
	"Selecione uma iniciativa ou objetivo": "Select an initiative or objective",
	"Todas ações": "All actions",
	"Valor despesa": "Expense value",
	"Valor liberado": "Released value",
	"Valor realizado despesa": "Realized value expense",
	"Valor realizado receita": "Realized value revenue",
	"Valor receita": "Revenue value",
	"Valor previsto despesa": "Expected value expense",
	"Valor previsto receita": "Expected value revenue",
	"Você está criando ações recorrentes até a data": "You are creating recurring actions to date"
};

export const ENActionsWorkspace = {
	"Cancelada": "Canceled",
	"Concluída": "Completed",
	"Em andamento": "In progress",
	"FCA - Indicador": "FCA - Indicator",
	"Iniciativa - Mapa": "Iniciative - Map",
	"Iniciativa - OKR": "Iniciative - OKR",
	"Não iniciada": "Not started",
	"Ocorrência": "Occurrence",
	"Projeto": "Project",
	"Risco": "Risk",
	"Sem ação": "Without action",
	"Sem análise": "Without analysis",
	"Sem classificação": "Without classification",
	"Sem fase": "Without phase",
	"Sem kanban": "Without kanban",
	"Sem indicador": "Without indicator",
	"Sem iniciativa": "Without iniciative",
	"Sem objetivo": "Without objective",
	"Sem ocorrência": "Without occurrences",
	"Sem okr": "Without okr",
	"Sem origem": "Without origin",
	"Sem perspectiva": "Without perspective",
	"Sem programa": "Without program",
	"Sem projeto": "Without project",
	"Sem quadrante": "Without quadrant",
	"Sem mapa estratégico": "Without strategy map",
	"Sem reunião": "Without meeting",
	"Sem resultado chave": "Without key result",
	"Sem riscos": "Without risks",
	"Sem setor": "Without sector"
};

export const BRActionsWorkspace = {
};

export const BRTraceabilityActionsWorkspace = {
};

export const ENTraceabilityActionsWorkspace = {
	"Ação": "Action",
	"FCA - Indicador": "FCA - Indicator",
	"Iniciativa - Mapa": "Iniciative - Map",
	"Iniciativa - OKR": "Iniciative - OKR",
	"Ocorrência": "Occurrence",
	"Projeto": "Project",
	"Reunião": "Meeting",
	"Risco": "Risk",
	"Sem origem": "Without origin"
};

export default ENActions;
